<template>
  <v-app>
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      clipped-right
      app
      color="white"
      v-if="!$route.meta.hideNavigation"
    >
      <v-app-bar-nav-icon
        @click.stop="$store.commit('app/TOGGLE_MENU', !showMenu)"
      ></v-app-bar-nav-icon>
      <v-toolbar-title style="width: 300px;" class="ml-0 pl-4">
        <span class="hidden-sm-and-down primary--text">{{ portal_name }}</span>
      </v-toolbar-title>
      <v-spacer />
      <help-menu></help-menu>
      <v-img
        contain
        max-width="100px"
        height="50px"
        :src="logo"
        alt="EOMAP Logo"
      ></v-img>
    </v-app-bar>
    <router-view name="menu"></router-view>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import HelpMenu from "@/components/general/HelpMenu";
import { mapState } from "vuex";

export default {
  name: "App",
  components: {
    HelpMenu
  },
  data: () => ({
    portal_name: "eoApp Guyana",
    logo: require("@/assets/general/EOMAP_detect_logo.jpg")
  }),
  computed: {
    ...mapState("app", ["showMenu"])
  }
};
</script>
